import { render, staticRenderFns } from "./ValidateCuttingPleatingDetailPage.vue?vue&type=template&id=73003579"
import script from "./ValidateCuttingPleatingDetailPage.vue?vue&type=script&lang=js"
export * from "./ValidateCuttingPleatingDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports